import React from 'react';
import { connect } from 'react-redux';
import { Table, ToggleButtonGroup, ToggleButton, Badge, Button } from 'react-bootstrap';
import uniqBy from 'lodash.uniqby';

//Actions
import { pesquisa, novoatualiza, pesquisaBaseCategorias, removeCategoriaForm, novacategoriaForm } from '../../../../actions/forms/validacao';

//Components
import FormConfValidacaoFormsSubLista from './FormConfValidacaoFormsSubLista';

//Utils
import { getEvento } from '../../../../utils/eventosession';

//Helpers
import { TelaModalLivre } from '../../../../helpers/TelaModal';

class FormConfValidacaoForms extends React.Component {

    state = {
        categoria: false,
        linguagem: 'pt',
        campos: {},
        showModal: false,
        baseCategoria: {}        
    }

    evento = getEvento();

    async componentDidMount(){        
        this.handlePesquisaFormularios();        
        this.setState({            
            baseCategoria: await this.props.pesquisaBaseCategorias({
                idpromotora: this.evento.idpromotora, 
                idevento: this.evento.idevento
            })
        });
    }

    handlePesquisaFormularios = async () => {
        const dados = await this.props.pesquisa({
            idpromotora: this.evento.idpromotora, 
            idevento: this.evento.idevento        
        });

        this.setState({
            campos: dados
        });

        return dados;
    }

    handleNovoFormularioValida = () => {

    }
    
    handleEditar = async (value, item) => {    

        const evento = getEvento();        
        const campoupdate = this.state.campos.map(itens => {
            let linha = {};
            if(itens.id === item.id){
                linha = {
                    ...itens,
                    [value.campo]: value.value
                } 
                return linha;
            }else{
                return itens;
            }
        });

        const dados = { 
            id: item.id,
            idevento: item.idevento,
            idpromotora: evento.idpromotora,
            [value.campo]: value.value
        }

        await this.props.novoatualiza(dados);
        this.setState({
            campos: campoupdate
        });
    }

    handleCategoria = (categoria) => {
        this.setState({
            categoria: this.state.categoria===categoria?false:categoria
        });
    }
    
    handleLinguagem = (lg) => {
        this.setState({
            linguagem: lg
        })
    }

    handleCloseTelamodal = () => {
        this.setState({
            showModal: this.state.showModal===true?false:true
        });
    }
            
    render() {        
        const categorias_escolha = uniqBy(this.state.campos&&this.state.campos.length?this.state.campos:[],'categoria');        
        return (
            <>
                <TelaModalLivre show={this.state.showModal} handleCloseModal={this.handleCloseTelamodal} titulo="Categoria de Formulários">
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Categoria</th>
                            <th>Habilitado</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.baseCategoria&&Object.keys(this.state.baseCategoria).length?
                        this.state.baseCategoria.map((itens, indice) => {
                            let existe = [];
                            if(this.state.campos && this.state.campos.length){
                                existe = this.state.campos.filter(campos => {
                                    return itens.categoria===campos.categoria;
                                });
                            }                            
                            return (
                                <tr key={indice}>
                                    <td>
                                        {itens.descricao}
                                    </td>
                                    <td>             
                                        {existe.length?                           
                                        <Button 
                                        type="button"
                                        variant="warning"
                                        onClick={() => {
                                            this.props.removeCategoriaForm({idevento: getEvento().idevento, idpromotora: getEvento().idpromotora, categoria: itens.categoria});
                                            this.handlePesquisaFormularios();
                                            this.handleCloseTelamodal();
                                        }} 
                                        >
                                            Remover
                                        </Button>                                        
                                        :
                                        <Button 
                                        type="button"
                                        variant="success"
                                        onClick={() => {
                                            this.props.novacategoriaForm({idevento: getEvento().idevento, idpromotora: getEvento().idpromotora, categoria: itens.categoria});
                                            this.handlePesquisaFormularios();
                                            this.handleCloseTelamodal();
                                        }} 
                                        >
                                            Adicionar
                                        </Button>
                                        }                                      
                                    </td>
                                </tr>
                            )
                        })
                        :
                        null
                        }
                    </tbody>
                </Table>
                </TelaModalLivre>
                <div className="card text-center">
                    <p> 
                        <Badge variant="success">
                            Linguagem
                        </Badge>
                    </p>
                    <ToggleButtonGroup type="checkbox" value={this.state.linguagem} className="mb-2">
                        <ToggleButton onChange={(e) => this.handleLinguagem(e.currentTarget.value)} type="radio" variant="primary" value="pt" checked={this.state.linguagem==='pt'?true:false}>Português</ToggleButton>
                        <ToggleButton onChange={(e) => this.handleLinguagem(e.currentTarget.value)} type="radio" variant="primary" value="en" checked={this.state.linguagem==='en'?true:false}>Inglês</ToggleButton>
                        <ToggleButton onChange={(e) => this.handleLinguagem(e.currentTarget.value)} type="radio" variant="primary" value="es" checked={this.state.linguagem==='es'?true:false}>Espanhol</ToggleButton>
                    </ToggleButtonGroup>
                </div> 
                <Table striped bordered hover style={{paddingBottom: '150px', marginBottom: '150px'}}> 
                    <thead>
                        {categorias_escolha.map((itens, indice) => {                                    
                            return (                                                                        
                                <tr 
                                className={`bg-info text-center ${itens.categoria===this.state.categoria?'font-weight-bold':''}`}                                
                                key={indice}
                                style={{cursor: 'pointer'}} onClick={() => this.handleCategoria(itens.categoria)}>
                                    <td className="text-break" colSpan="4">
                                        {itens.baseformcategoria.descricao}
                                    </td>
                                </tr>                                
                            )                            
                        })}
                    </thead>
                    
                    {this.state.categoria!==false?
                    <FormConfValidacaoFormsSubLista
                        linguagem={this.state.linguagem}
                        cadastros={[...this.state.campos&&this.state.campos.filter(itens => (itens.categoria === this.state.categoria && itens.linguagem===this.state.linguagem))]} 
                        categoria={this.state.categoria}                                
                        handleEditar={this.handleEditar}
                    />
                    :
                    null
                    }                    
                </Table>        
                <Button block onClick={this.handleCloseTelamodal}>Novo Formulário</Button>            
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {        
        pendingTasks: state.pendingTasks        
    }
}

export default connect(mapStateToProps, { pesquisa, novoatualiza, pesquisaBaseCategorias, removeCategoriaForm, novacategoriaForm })(FormConfValidacaoForms);